// eslint-disable-next-line @typescript-eslint/no-var-requires
const DefaultConfig = require('../../tailwind.config');

module.exports = DefaultConfig;
